import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { _Inbox, _single } from "../../../core/services/dataBean/EntityCatalog";
import { BasicTable } from "../../theme/Component/BasicTable";
import { ListMenu } from "../../theme/Component/ListMenu";
import { toast } from "react-toastify";
import { Modal } from "../../theme/Component/Modal";
import { RenderInbox } from "../PersonaInbox/RenderInbox";
import { ResumeImp } from "../config/InfoTramiteComponents/ResumeImp/ResumeImp";
import { NotesImp } from "../config/InfoTramiteComponents/NotesImp/NotesImp";
import { CardTramitesHistory } from "../config/InfoTramiteComponents/HistoryImp/CardTramitesHistory";
import { PrintJson } from "../../theme/Component/PrintJson";
import { CardTaps } from "../../theme/Component/CardTaps";
import { DocumentsImp } from "../config/InfoTramiteComponents/DocumentsImp/DocumentsImp";

interface Props {
    Procedure: { IDProcedureImp: number };
    requestLista: Function;
}
export const BPMProcedureAction = ({ Procedure, requestLista }: Props) => {

    const { instance, setBean, bean, lista, setLista } = useDataBean(_Inbox)
    const [modalAction, setModalAction] = useState<any>({ name: 'Documentos requeridos', tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-lg' });

    useEffect(() => {
        getLista();
    }, [Procedure])

    const getLista = () => {
        instance.getProcedureActionByAccount(_single.getAccountID(), Procedure.IDProcedureImp, null).then(
            (resp) => {
                if (resp.length >= 1) {
                    setLista(resp)
                } else {
                    toast.info("No se tiene actividades pendientes");
                    requestLista();
                }
            }
        ).catch(err => { console.log(err) })
    }

    const head = [
        { title: 'Pendiente', property: 'Name', visible: true },
        { title: 'Estado', property: 'StateName', visible: true },
        { title: 'Acción', property: 'ProcedureName', visible: true },
        { title: 'Fecha', property: 'Since', visible: true },
    ]

    useEffect(() => {
        if (modalAction.view === false) {
            setBean({})
        }
    }, [modalAction.view])

    useEffect(() => {
        if (bean.IDAction) {
            setModalAction({ ...modalAction, "view": true, "name": `Actividad - ${bean.Name}` });
        }
    }, [bean])

    const taps = [
        { id: 0, name: 'Gestión' },
        { id: 1, name: 'Resumen' },
        { id: 2, name: 'Notas' },
        { id: 3, name: 'Historial' },
        { id: 4, name: 'Documentos', disable: false }
    ]

    const [indexTap, setIndexTap] = useState(0);

    return (
        <div className="row">
            {lista.length > 0 ?
                <>
                    <BasicTable body={lista} head={head} rowSet={setBean} />
                </>
                :
                <div className='border rounded p-5 text-justify'>
                    <p>
                        Estimado usuario usted NO tiene acciones pendientes por gestionar en
                        esta solicitud.
                        <br />
                        <br />
                        Si el estado de su solicitud está <strong className='text-primary'>EN PROGRESO</strong> debe esperar
                        a que las próximas actualizaciones le sean notificadas.
                    </p>
                </div>
            }
            

            <div className="col-md-12">
                <Modal modal={modalAction} updateModal={setModalAction} 
                // evenOnClose={()=>{getLista();console.log("Cerrando BPMProcedureAction");}}
                 >
                    <CardTaps taps={taps} index={indexTap} updateIndex={setIndexTap} >
                        <div className="row">
                            <div className="col-md-12">
                                {indexTap === 0 &&
                                    <RenderInbox procedure={Procedure} key={bean.IDAction} action={bean} requestListAction={() => { getLista(); 
                                        setModalAction({ ...modalAction, "view": false }); 
                                    }} />
                                }
                                {indexTap === 1 &&
                                    <ResumeImp IDProcedureImp={Procedure.IDProcedureImp} />
                                }
                                {indexTap === 2 &&
                                    <NotesImp Action={bean} />
                                }
                                {indexTap === 3 &&
                                    <CardTramitesHistory ID={Procedure.IDProcedureImp} />
                                }
                                {indexTap === 4 &&
                                    <div className="col-md-12">
                                        <DocumentsImp ID={Procedure.IDProcedureImp} />
                                    </div>
                                }
                            </div>
                        </div>
                    </CardTaps>
                </Modal>
            </div>
        </div>
    )
}